import type * as React from 'react';

import { cn } from '~/utils/cn.ts';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	ref?: React.Ref<HTMLInputElement>;
}

function Input({ className, type, ref, ...props }: InputProps) {
	return (
		<input
			className={cn(
				// Base styles - Lyra style: sharp corners, smaller text
				'flex h-8 w-full px-2.5 py-1.5',
				'rounded-none border border-input bg-transparent',
				'text-foreground text-xs',
				// Focus styles
				'outline-none focus-visible:border-ring focus-visible:ring-1 focus-visible:ring-ring/50',
				// Placeholder
				'placeholder:text-muted-foreground',
				// File input
				'file:border-0 file:bg-transparent file:font-medium file:text-foreground file:text-xs',
				// Selection
				'selection:bg-primary selection:text-primary-foreground',
				// Disabled
				'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
				// Aria invalid
				'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
				'aria-invalid:border-destructive aria-invalid:ring-1 dark:aria-invalid:border-destructive/50',
				className,
			)}
			data-slot="input"
			ref={ref}
			type={type}
			{...props}
		/>
	);
}

export { Input };
